import { useState } from 'react';
import { ProfileDropdown } from './ui/ProfileDropdown';
import { SearchBar } from './ui/SearchBar';
import { QuickLinksOverlay } from './ui/QuickLinksOverlay';
import { useAuth } from '../hooks/useAuth';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';

export default function Navbar() {
  const { logout, user } = useAuth();
  const [isQuickLinksOpen, setIsQuickLinksOpen] = useState(false);

  const handleQuickLinksOpen = () => {
    setIsQuickLinksOpen(true);
  };

  const handleQuickLinksClose = () => {
    setIsQuickLinksOpen(false);
  };

  useKeyboardShortcuts({ onQuickLinksOpen: handleQuickLinksOpen });

  return (
    <>
      <div className="hidden lg:flex h-12 bg-theme-light-sidebar dark:bg-theme-dark-sidebar items-center justify-between px-4 pt-2">
        {/* Left spacer to center the search bar */}
        <div className="flex-1" />

        {/* Search bar in the center */}
        <SearchBar onQuickLinksOpen={handleQuickLinksOpen} />

        {/* Right side with profile dropdown */}
        <div className="flex items-center flex-1 justify-end">
          {user && <ProfileDropdown user={user} onLogout={logout} />}
        </div>
      </div>

      <QuickLinksOverlay isOpen={isQuickLinksOpen} onClose={handleQuickLinksClose} />
    </>
  );
}
